module.exports = __webpack_public_path__ + "img/icon-scrollup.2c4fdab4.svg";